import { Card, Table, Button } from '@insight-health-ai/roseate/components';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useGetCallInfiniteList, UseGetCallListParams } from 'src/hooks/call';
import { getColumns } from './constants';

export const CallList = () => {
  const [filters] = useState<UseGetCallListParams>({
    product: 'frontdesk',
  });

  const {
    data,
    isLoading,
    error,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useGetCallInfiniteList(filters);
  const navigate = useNavigate();

  if (error) {
    return (
      <div className="flex justify-center items-center p-8">
        <div className="text-red-500 text-lg">Error loading calls</div>
      </div>
    );
  }

  const calls = data?.pages.flatMap((page) => page.callList) || [];

  return (
    <div
      style={{ height: 'calc(100dvh - 100px)' }}
      className="page-wrapper care-connect-page flex flex-col gap-2 h-full"
    >
      {/* <CallsAnalytics /> */}

      <Card title="Recent Calls" padding={{ body: 'none' }}>
        <Table
          columns={getColumns({
            filters,
            onPreview: (record) =>
              navigate(`/frontdesk/calls/${record.call_id}`),
          })}
          data={calls}
          loading={isLoading}
          getRowProps={(record) => ({
            onDoubleClick: () => navigate(`/frontdesk/calls/${record.call_id}`),
            className: 'hover:bg-gray-50',
          })}
          pagination={false}
          footer={() => {
            if (!hasNextPage) {
              return null;
            }

            return (
              <div className="flex p-2 justify-center">
                <Button
                  loading={isFetchingNextPage}
                  onClick={() => {
                    fetchNextPage();
                  }}
                >
                  Show more
                </Button>
              </div>
            );
          }}
          emptyText="No calls found"
        />
      </Card>
    </div>
  );
};
